import PageHeaderText from 'components/base/page-header-text';
import React, { useCallback, useEffect, useState } from 'react';
import { ALL } from 'utils/constants';
import { ENUM_RETURNS_STATUS } from 'models/common.model';
import ExcessReturnsFilter from './excess-returns-filter';
import ReturnsCard from 'components/returns-card';
import { apiService } from 'services/base.service';
import { toast } from 'react-toastify';
import { ToastMessage } from '@cokitchen/cokitchen-components';
import ActivityIndicator from 'components/base/loader/activityIndicator';
import { debounce } from 'utils/functions';
import useDashboardContext from 'contexts/dashboard.context';

export type ExtendedReturnsType = ENUM_RETURNS_STATUS | typeof ALL;
export type FilterType = {
  search: string;
  status: ExtendedReturnsType;
  dateRange: { startDate: Date; endDate: Date };
};

export type ExcessReturnsType = {
  cokitchen_id: string;
  id: string;
  note: string;
  status: ENUM_RETURNS_STATUS;
  created_at: string;
  items: {
    id: string;
    ingredient_id: string;
    quantity: 3;
    return_id: string;
    ingredient: {
      id: string;
      category: string;
      min_vendor_price: string;
      min_quantity: string;
      unit_type: string;
      unit_weight: string;
      name: string;
    };
  }[];
};

const ExcessReturns = () => {
  const [filters, setFilters] = useState({
    search: '',
    status: ALL,
    dateRange: {
      startDate: new Date(),
      endDate: new Date()
    }
  } as FilterType);
  const [isFetchingExcessReturns, setIsFetchingExcessReturns] = useState(false);
  const [excessReturns, setExcessReturns] = useState<ExcessReturnsType[]>([]);
  const [lastPage, setLastPage] = useState(1);
  const [currentPage, setCurrentPage] = useState(1);
  const { activeStore } = useDashboardContext();

  // useEffect(() => {
  //   const filteredExcessReturns = excessReturns.filter((excess_return) =>
  //     excess_return.order_code.includes(filters.search)
  //   );
  //   setFilteredExcessReturns(excessReturns);
  // }, [filters.search]);

  // useEffect(() => {
  //   const filteredExcessReturns = excessReturns.filter(
  //     (excess_return) => excess_return.status === filters.status
  //   );
  //   if (filters.status !== ALL) {
  //     setFilteredExcessReturns(filteredExcessReturns);
  //   } else {
  //     setFilteredExcessReturns(excessReturns);
  //   }
  // }, [filters.status]);

  const fetchExcessReturns = async (
    startDate: Date,
    endDate: Date,
    search: string,
    status: ExtendedReturnsType,
    page: number
  ) => {
    if (!activeStore?.id) return;
    try {
      setIsFetchingExcessReturns(true);
      const response = await apiService.get(
        `kitchen-store/stores/${activeStore?.id}/kitchen-return?page=${page}`
      );
      if (response) {
        setExcessReturns(response?.data?.results);
        setLastPage(Math.ceil(response?.data?.total / 10));
      }
    } catch (err: any) {
      toast(
        <ToastMessage
          type='error'
          message={err.response?.data?.message || 'Error fetching excess returns'}
        />
      );
    } finally {
      setIsFetchingExcessReturns(false);
    }
  };

  const debounceFetchExcessReturns = useCallback(debounce(fetchExcessReturns, 1000), []);

  useEffect(() => {
    setIsFetchingExcessReturns(true);
    setExcessReturns([]);
    debounceFetchExcessReturns(
      filters.dateRange.startDate,
      filters.dateRange.endDate,
      filters.search,
      filters.status,
      currentPage
    );
  }, [filters, currentPage]);

  return (
    <div>
      <PageHeaderText
        title='Excess returns'
        description='Track excess items returned by the kitchen store'></PageHeaderText>
      <ExcessReturnsFilter
        filters={filters}
        setFilters={setFilters}
        lastPage={lastPage}
        setCurrentPage={setCurrentPage}
      />
      {isFetchingExcessReturns ? (
        <div>
          <ActivityIndicator />
        </div>
      ) : excessReturns.length > 0 ? (
        <div className='mt-10 gap-7 grid grid-cols-3 max-[1250px]:grid-cols-2 max-[768px]:grid-cols-1'>
          {excessReturns.map((p, i) => (
            <ReturnsCard key={i} returns={p} />
          ))}
        </div>
      ) : (
        <div>
          <h4 className='text-sm text-center'>No result</h4>
        </div>
      )}
    </div>
  );
};

export default ExcessReturns;
